// @ts-nocheck

// Card
const MIN_WIDTH_CARD = 340;
const MAX_CARD_PER_LINE = 5;

// Storage
const KEY = 'multiview';
const VERSION = 1;

export const MultiviewStyles = {
  MIN_WIDTH_CARD,
  MAX_CARD_PER_LINE,
};

export const MultiviewStorage = {
  KEY,
  VERSION,
};
